export class EquipmentType {
    id = null;

    companyId = null;

    description = '';

    groups = [];

    employeeAssignableQuantity = null;

    resourceAssignableQuantity = null;

    requiredEquipment = [];

    equipmentTypeAFADTypeId = 1;

    isVehicle = false;

    isGeneric = false;

    payrollIncentives = [];
}

export class Equipment {
    id = null;

    description = '';

    equipmentTypeId = '';

    identifier = '';

    serial = '';

    equipmentStatusId = 1;

    employeeAssignedId = '';

    equipmentAssignedId = '';

    dispatchLocationId = '';
    equipmentTags = [];

    externalId = '';

    // New equipment is never NetSuite-owned, so every field stays editable until the
    // server says otherwise on a subsequent fetch.
    canEdit = true;
}
